import reducer from "./reducers";

import * as alumnosOps from "./operations";
import * as alumnosTypes from "./types";

export { alumnosOps, alumnosTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/alumnos/index.js